import { DOMType, } from '@tencent/exeditor3-core';
import '@tencent/exeditor3-ui-kit/dist/toolbar-button.js';
import { pickFile } from '@tencent/exeditor3-ui-kit/dist/utils.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
import { FilePlugin, fileStyles, uploadingContainerClassName, } from '@tencent/exeditor3-template-plugin-file';
const styles = `
${fileStyles}
.exeditor-audio.audio-container {
  position: relative;
  margin: 1em auto;
  width: fit-content;
}
.exeditor-audio.audio-container > audio {
  display: block;
  margin: 0;
  outline: none;
}
.exeditor-audio.audio-container > .handler {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  cursor: move;
  transform: translateY(-100%)
}
.exeditor-audio.audio-container.active > .handler {
  display: block;
}
.exeditor-audio.audio-container > .handler::after {
  content: attr(data-tip);
  display: block;
  color: #ccc;
  font-size: 12px;
}
span.exeditor-audio.audio-container {
  display: inline-block;
  margin: 0;
}
`;
const parseAudioInfoFromNode = (node) => {
    let audio = node;
    if (!(audio instanceof HTMLAudioElement)) {
        audio = node.querySelector('audio') || node;
    }
    return {
        src: audio.src || node.dataset.src || '',
        title: audio.title || node.dataset.title || '',
    };
};
const defaultOption = {
    upload: () => {
        throw new Error('upload() method has not been set.');
    },
    accept: 'audio/*',
    acceptFile: (file) => /^audio\//i.test(file.type),
};
export class AudioPlugin extends FilePlugin {
    constructor(options = {}) {
        super();
        this.name = 'audio';
        this.nameCN = '音频';
        this.spec = {
            type: DOMType.BLOCK,
            matchSelector: `.${uploadingContainerClassName}[data-plugin="audio"], audio`,
            attrs: {
                info: {
                    parse: parseAudioInfoFromNode,
                },
                ...this.fileAttrsSpec,
            },
            toDOM: (node) => {
                const isInline = this.options.inline;
                const { uploading, info } = node.attrs;
                if (uploading) {
                    return this.wrapUploadingDOMRule(node.attrs, {
                        tag: 'audio',
                        attributes: {
                            src: info.src,
                        },
                    });
                }
                return {
                    tag: 'audio',
                    attributes: {
                        ...info,
                        controls: '',
                        'data-inline': isInline ? '' : undefined,
                    },
                };
            },
            draggable: true,
        };
        this.editView = (initNode, getPos) => {
            let node = initNode;
            if (node.attrs.uploading) {
                return this.editPlaceholderView(node, getPos);
            }
            if (this.isNeedToUploadBySrc(node.attrs.info)) {
                this.uploadBySrc(node.attrs.info, getPos);
                return this.editPlaceholderView(node, getPos);
            }
            const isInline = this.options.inline;
            const { src } = node.attrs.info;
            const audio = document.createElement('audio');
            audio.src = src;
            audio.controls = true;
            audio.setAttribute('controlsList', 'nodownload noplaybackrate');
            const container = document.createElement(isInline ? 'span' : 'div');
            container.className = 'exeditor-audio audio-container';
            const handler = document.createElement('div');
            handler.className = 'handler';
            handler.draggable = true;
            handler.dataset.tip = this.editor.t('拖动此处调整位置');
            container.appendChild(audio);
            container.appendChild(handler);
            audio.addEventListener('focus', () => {
                // 防止编辑器焦点丢失
                this.editor.selection().setNode(getPos());
                this.editor.focus();
            });
            const handleSelect = () => {
                container.classList.add('active');
                if (!this.editor.isReadOnly()) {
                    handler.style.display = 'block';
                }
            };
            const handleDeSelect = () => {
                container.classList.remove('active');
                handler.style.display = 'none';
            };
            this.editor.on('readonly', (readOnly) => {
                if (readOnly) {
                    handleDeSelect();
                }
            });
            return {
                dom: container,
                update: (updatedNode) => {
                    node = updatedNode;
                    const { src } = node.attrs.info;
                    if (src !== audio.src) {
                        return false;
                    }
                    return true;
                },
                selectNode: handleSelect,
                deselectNode: handleDeSelect,
            };
        };
        this.options = {
            ...defaultOption,
            ...options,
        };
        this.spec.type = this.options.inline ? DOMType.INLINE_BLOCK : DOMType.BLOCK;
    }
    initEditor(editor) {
        this.editor = editor;
    }
    capabilities() {
        const capabilities = super.capabilities();
        return {
            ...capabilities,
            styles,
        };
    }
    renderToolbarItem() {
        const btn = document.createElement('exeditor-toolbar-button');
        Object.assign(btn, {
            label: this.editor.t('音频'),
            onclick: () => {
                pickFile(this.options.accept, true).then((files) => {
                    if (!(files === null || files === void 0 ? void 0 : files.length)) {
                        return;
                    }
                    this.editor.focus();
                    this.insertByFiles(Array.from(files));
                });
            },
        }).append(createIcon({
            name: this.name,
            editor: this.editor,
            fallback: () => import('./icon.js').then((m) => m.audioIcon),
        }));
        return btn;
    }
    createContentElement(info) {
        const audio = document.createElement('audio');
        audio.src = info.src;
        audio.controls = true;
        return audio;
    }
    async getMetadata() {
        return {};
    }
}
//# sourceMappingURL=index.js.map